import { defineVariants } from "@/runtime/style-engine/define-variants";

/** Classes for the `<e-editor>` body (Monaco container). */
export const editorClasses = defineVariants({
  base: "block w-full ",
  variants: {},
  defaults: {},
});

/** Outer `<figure>` wrapper — carries the editor background. */
export const editorFigureClasses =
  "flex flex-col w-full rounded-lg overflow-hidden bg-(--color-secondary-950) ring ring-(--color-neutral)/15";

/** `<figcaption>` header bar — transparent so figure bg shows through. */
export const editorHeaderClasses = `
  flex items-center justify-between px-4 py-2 text-xs text-(--color-neutral-200) border-b border-(--color-neutral)/15 bg-(--color-secondary-950)`;

/** Language icon + label span inside the header. */
export const editorHeaderLabelClasses = "flex items-center gap-1.5";

/** Trailing slot span inside the header. */
export const editorHeaderTrailingClasses = "flex items-center gap-1";
